export default __webpack_public_path__ + "static/media/highContrastTheme.bcc0cc09.svg";